import { callApiToServer } from '../callApi';

export async function getBalanceReport(
  authtoken,
  startDate,
  endDate,
  filter,
  distributorId,
) {
  try{
    let header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      "authorization" : "Berear " + authtoken
    };
      
    let body = JSON.stringify({
        startDate : startDate,
        endDate : endDate
    });
    let endUrl = `v1/auth/list-balance-request-report?filterBy=${filter}${distributorId && "&distributorId="+distributorId}`
    console.log("endUrl printed here", endUrl);
  
    let responseData = await callApiToServer(body, header, "POST", endUrl);
      
    return responseData;
      
  }catch(err) {
    throw err;
  }
}
